export default {
  'title': 'dark',
  'text-title': '#D9D9D9',
  'text-body': '#A7A7A7',
  'text-techs': '#6CACE4',
  'background1': 'rgba(19,30,94,1)',
  'background2': 'rgba(12,13,19,1)',
  'cardBackground': '#456',
  'shadowOpacity': '0.8',
}